import { Pipe, PipeTransform } from '@angular/core';
import { constants } from 'src/environments/constants';
import {
    CritereModel
} from 'src/app/_shared/services/advanced-rule/advanced-rule.service';

@Pipe({
    name: 'isEqualOperator',
    standalone: false
})
export class IsEqualOperatorPipe implements PipeTransform {
    static format(criteriaList: CritereModel[], criteriaId: number): boolean {
        const criteria = !criteriaId ? null : (criteriaList || []).find(c => c.Id === criteriaId);
        return [constants.fieldsTypesCodes.LST, constants.fieldsTypesCodes.BOO].includes(criteria?.TypeDonnee?.Code);
    }

    transform(criteriaList: CritereModel[], criteriaId: number): boolean {
        return IsEqualOperatorPipe.format(criteriaList, criteriaId);
    }
}
